# Flash Message View
# ==================
SupportFlashTemplate = require('../../flash.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $

class SupportFlashView extends Backbone.View
  className: 'flash'

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @template = SupportFlashTemplate
    @type = @options.type
    unless @type?
      @type= 'info'
    @content = @options.content
    unless @options.sticky
      delay 20000, => @remove()

  render: ->
    @$el.addClass(@type)
    @$el.html toHtml(@template, @toHash(), @template)

  events: ->
    'click .close': 'remove'

  toHash: ->
    content: @content

  close: ->
    # Write close logic for this view here

module.exports = SupportFlashView
